import React from "react";
import * as styles from "./styles.mod.scss";
import BlueCheckmark from "assets/svgs/blue-checkmark.svg";
import getImagePath from "helpers/get-image-path";

const CookingHub = ({ data }) => {
  const { chefImage, chefName, text } = data;

  return (
    <div className={styles.cookingHub} id="cooking-hub">
      {chefImage &&
        <div className={styles.chefImg}>
          <img src={getImagePath(chefImage)} alt={chefImage?.alt} />
        </div>}
      <p className={styles.text}>
        {chefName} <BlueCheckmark /> {text}
      </p>
    </div>
  );
};

export default CookingHub;